module.exports = __webpack_public_path__ + "img/grand-palm-kids.2ce1aab9.jpg";